import React, { useCallback, useState, useRef } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { GridLayout } from "../../../../common/GridLayout";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
  Export,
  Pager,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
  ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import route from "../../../../assets/apiRoutes.json";
import GridLayoutManager from '../../../../gridLayoutCustomization/GridLayoutManager';



const InspectionTab = (props) => {
    const dataGrid = useRef(null);
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "6D3BBAB2-2CF7-453B-B509-00FF35C63F29";
    const [currentLayout, setCurrentLayout] = useState("Default");
    var loadInspectoinUrl = "ab/InspectionData/GetInspectionDetails";
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);

    const resultData = createStore({
        key: 'rowid',
        loadParams:
        {
            sourceId: function () {
                return props.sourceId;
            },
        },
        loadUrl: `${window._env_.REACT_APP_APIS}/${loadInspectoinUrl}`,
        onBeforeSend: (method, ajaxOptions) => {
            ajaxOptions.headers = {
                access_token: accessToken,
                Authorization: `Bearer ${accessToken}`,
            };
        },
    });
    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion" >

                        <div>
                            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                                ref={dataGrid}
                                dataSource={resultData}
                                allowColumnReordering={true}
                                allowColumnResizing={true}
                                showBorders={true}
                                hoverStateEnabled={true}
                                remoteOperations={true}
                                searchEnabled={true}
                                columnAutoWidth={true}
                            >
                                <ColumnChooser
                                    enabled={true}
                                    title="Choose Column"
                                    width={290}
                                    height={290}
                                    sortOrder="asc"
                                >
                                    <ColumnChooserSearch
                                        enabled={true}
                                        editorOptions={{ placeholder: 'Search column' }} />
                                </ColumnChooser>
                                <Export enabled={true} allowExportSelectedData={true} />
                                <Sorting visible={true} mode="multiple" />
                                <Paging defaultPageSize={10} />
                                <Pager
                                    visible={true}
                                    showPageSizeSelector={true}
                                    allowedPageSizes={allowedPageSizes}
                                    showNavigationButtons={true}
                                />
                                <FilterRow visible={true} />
                                <FilterPanel visible={true} />
                                <GroupPanel visible={true} />
                                <Grouping autoExpandAll={false} />
                                <StateStoring
                                    enabled={true}
                                    type="custom"
                                    customLoad={loadState}
                                    storageKey={gridKey}
                                    customSave={saveState}
                                />
                                <Column dataField="fieldname" caption="Name" dataType='string' />
                                <Column dataField="fieldValue" caption="Entered Value" dataType='string' />
                                <GridToolbar>
                                    <GridToolbarItem location="after">
                                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                                    </GridToolbarItem>
                                    <GridToolbarItem name="exportButton" />
                                    <GridToolbarItem name="columnChooserButton" />
                                </GridToolbar>
                            </DataGrid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}
export default connect(mapStateToProps)(InspectionTab);